<template>
  <div class="checkbox-container">
    <input :id="id" class="input" type="checkbox"
           @input="updateInput"
           :checked="value">
    <div class="checkmark"></div>
    <label :for="id" class="label">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    value: {
      type: [String, Boolean],
      required: false
    },
  },
  methods: {
    updateInput(e) {
      this.$emit('input', e.target.checked)
    }
  },
  watch: {
    value() {
      this.$emit('change')
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../styles/variables' as v;

$size: 15px;
$offset: 2px;

.checkbox-container {
  cursor: pointer;
  display: inline-block;
  transition: opacity 0.06s ease;
  position: relative;

  .input {
    display: none;
  }

  .input:checked ~ .label:before {
    background: desaturate(v.$sharp-blue, 20);
  }

  .input:checked ~ .checkmark {
    display: inline-block;
  }

  .label {
    position: relative;
    cursor: pointer;
    height: v.$font-size-smaller;
    display: inline-block;
    top: -$offset;
    padding-left: $size + 5px;

    &:before {
      position: absolute;
      left: 0;
      top: $offset;
      content: '';
      width: $size;
      height: $size;
      border-radius: 2px;
      background: v.$dark-white;
      transition: background 0.06s ease;
    }
  }

  .checkmark {
    display: none;
    width: 22px;
    height: 22px;
    transform: rotate(45deg);
    z-index: 100;
    position: absolute;
    pointer-events: none;

    &:before {
      content: '';
      position: absolute;
      width: 3px;
      height: 9px;
      background-color: white;
      left: 6px;
      top: 6px;
    }

    &:after {
      content: '';
      position: absolute;
      width: 3px;
      height: 3px;
      background-color: white;
      left: 3px;
      top: 12px;
    }
  }
}
</style>
